module.exports = __webpack_public_path__ + "3caeabb3fa37a584c680dd147c61d710.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/happy-13.png
// module id = 2140
// module chunks = 0